module.exports = __webpack_public_path__ + "static/img/storage2.20f2f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storage2.png
// module id = i00x
// module chunks = 2